export const TAG_LIST_SYMBOL = "LIST" as const;
